import React, { useState, useEffect } from 'react';
import { Button, Grid, MenuItem } from '@material-ui/core';
import Modal from './Modal';
import { CustomTextField } from '../Textfield';
import moment from 'moment';
import { FileUploader } from '../UI';
import { connect } from 'react-redux';
import {
    UploadStaffInfo,
    BulkUploadStaffs,
    UploadSlot,
    UploadEarningsExternalClient,
    UploadBulkHubs,
    UploadBulkBDVendors,
    UploadBulkVendorsToHubs,
    UploadBulkEmpIDMapping,
} from '../../store/actions/staffActionCreator';
import {
    bulkAssignDedicatedSlots,
    uploadTitanAdjustment,
    multiOrgSlotBulkUpload,
    getCapacityApprovers,
} from '../../store/actions/settingsActionCreator';
import { createWeeksList, showMessage } from '../../utils/helper';
import { useDebounce } from '../../hooks/useDebounce';
import { resolveApproverNames, RoutedToLine } from '../../utils/capacityApproval';

// const useStyles = makeStyles((theme) => ({
//     modal: {},
// }));

function UploadPayEarnModal({
    open,
    onClose,
    enumType = 'payment',
    data = {},
    uiData,
    dispatchUploadStaffInfo,
    dispatchBulkUploadStaffs,
    dispatchBulkUploadSlots,
    dispatchBulkAssignSlots,
    dispatchUploadClientsEarnings,
    dispatchBulkUploadHubs,
    dispatchBulkUploadBDVendors,
    dispatchBulkUploadVendorsToHubs,
    dispatchUploadBulkEmpIDMapping,
    dispatchUploadTitanAdjustment,
    dispatchMultiOrgSlotBulkUpload,
    dispatchGetCapacityApprovers,
    ...props
}) {
    const { debounce, isBouncing } = useDebounce();
    let isUploadEarnigs = enumType === 'earning';
    let isVendorsToHubMapping = enumType === 'vendors_to_hub';
    let isBulkHub = enumType === 'bulk_hub';
    let isBulkVendor = enumType === 'bulk_vendor';
    let isBulkEmpIDMapping = enumType === 'emp_id_mapping';
    let isSlotAssign = enumType === 'slot_assign';
    let isSlotsUpload = enumType === 'slots';
    let isMultiOrgSlotsUpload = enumType === 'slots_multi_org';
    let isTitanAdjustment = enumType === 'titan_adjustment';

    // const classes = useStyles();
    const [isOpen, toggleModal] = useState(open);
    const [loading, toggleLoading] = useState(false);
    const [isSubmitDisabled, setSubmitDisabled] = useState(true);
    const [reportUrl, setReportUrl] = useState(null);
    // Slot Capacity Approval — set when a slot upload comes back WITHHELD (whole file routed for
    // approval, nothing applied). Distinct from reportUrl: there's no result file to link to here.
    const [withheldInfo, setWithheldInfo] = useState(null);
    // Set on a clean/APPLIED slot upload — shown instead of an automatic redirect-and-close, same
    // click-through-the-link pattern as reportUrl below.
    const [appliedInfo, setAppliedInfo] = useState(null);
    const [earningsClient, setEarningsClient] = useState('Others');
    const [earningsFor, setEarningsFor] = useState('Daily');
    const [weekList, setWeekList] = useState(createWeeksList());
    const [selectedWeek, setSelectedWeek] = useState({});
    const handleClose = () => {
        setState(null);
        setStateStatus(null);
        setReportUrl(null);
        setWithheldInfo(null);
        setAppliedInfo(null);
        toggleModal(!isOpen);
        onClose && onClose();
    };
    const [state, setState] = useState({});
    const [stateStatus, setStateStatus] = useState({
        staffName: {},
        phoneNumber: {},
        vehicleNumber: {},
    });

    useEffect(() => {
        setSubmitDisabled(!state?.s3FileUrl);
    }, [state?.s3FileUrl]);

    useEffect(() => {
        setSelectedWeek(weekList?.[weekList?.length - 1]?.value || null);
    }, [weekList, earningsFor]);

    // Slot Capacity Approval — shared by the ordinary per-hub slot upload (`enumType==='slots'`)
    // and the network-wide multi-org upload (`enumType==='slots_multi_org'`): both return the
    // same discriminated response shape (status: APPLIED | WITHHELD), 200-wrapped either way —
    // never a distinct HTTP/business status code (see artifacts/slot-capacity-approval-fe-plan.md).
    const handleSlotUploadResponse = (response) => {
        const body = response?.response ?? {};
        if (body?.status === 'WITHHELD') {
            dispatchGetCapacityApprovers(
                (aResp) => {
                    const approverNames = resolveApproverNames(body.routedToTier, {
                        approvers: aResp?.response?.approvers,
                        roleChain: aResp?.response?.roleChain,
                    });
                    setWithheldInfo({ ...body, approverNames });
                },
                () => setWithheldInfo(body),
            );
            return;
        }
        setAppliedInfo(body);
    };

    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className={`cancelButton`}
            onClick={handleClose}
            disableElevation
        >
            {reportUrl || withheldInfo || appliedInfo ? 'Close' : 'Cancel'}
        </Button>,
        <Button
            key={2}
            variant="contained"
            color="primary"
            className={`saveButton`}
            style={{ display: reportUrl || withheldInfo || appliedInfo ? 'none' : undefined }}
            disabled={!!isSubmitDisabled || isBouncing || !state?.s3FileUrl}
            disableElevation
            onClick={() => {
                debounce(async () => {
                    if (!state?.s3FileUrl) {
                        showMessage('Please upload file', 'error');
                        return false;
                    }
                    toggleLoading(true);
                    setSubmitDisabled(true);
                    if (enumType === 'payment' || enumType === 'earning') {
                        if (isUploadEarnigs && earningsClient != 'Others') {
                            dispatchUploadClientsEarnings(
                                {
                                    fileName: state?.s3FileUrl,
                                    clientName: earningsClient?.toUpperCase(),
                                    ...(earningsFor === 'Weekly' && {
                                        weekLastDate: selectedWeek,
                                    }),
                                },
                                (response) => {
                                    toggleLoading(false);
                                    setSubmitDisabled(false);
                                    console.log('s3FileUrl response', response);
                                    if (response?.response?.s3FileUrl) {
                                        window.location.href =
                                            response?.response?.s3FileUrl;
                                    }
                                    handleClose();
                                },
                                (resp) => {
                                    toggleLoading(false);
                                    setSubmitDisabled(false);
                                },
                            );
                        } else {
                            dispatchUploadStaffInfo(
                                enumType,
                                {
                                    fileName: state?.s3FileUrl,
                                },
                                (response) => {
                                    toggleLoading(false);
                                    setSubmitDisabled(false);
                                    console.log('s3FileUrl response', response);
                                    if (response?.response?.s3FileUrl) {
                                        window.location.href =
                                            response?.response?.s3FileUrl;
                                    }
                                    handleClose();
                                },
                                (resp) => {
                                    toggleLoading(false);
                                    setSubmitDisabled(false);
                                },
                            );
                        }
                    } else if (enumType === 'slots') {
                        dispatchBulkUploadSlots(
                            { ...data, fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                handleSlotUploadResponse(response);
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isMultiOrgSlotsUpload) {
                        dispatchMultiOrgSlotBulkUpload(
                            state?.s3FileUrl,
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                handleSlotUploadResponse(response);
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isSlotAssign) {
                        dispatchBulkAssignSlots(
                            { ...data, fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                showMessage(
                                    'Slots assigned successfully',
                                    'success',
                                );
                                if (response?.response?.s3FileUrl) {
                                    window.location.href =
                                        response?.response?.s3FileUrl;
                                }
                                handleClose();
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isBulkHub) {
                        dispatchBulkUploadHubs(
                            { fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                console.log('s3FileUrl response', response);
                                if (
                                    response?.response?.s3FileUrl ||
                                    response?.response?.fileURL
                                ) {
                                    window.location.href =
                                        response?.response?.s3FileUrl ||
                                        response?.response?.fileURL;
                                }
                                handleClose();
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isBulkVendor) {
                        dispatchBulkUploadBDVendors(
                            { fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                console.log('s3FileUrl response', response);
                                if (
                                    response?.response?.s3FileUrl ||
                                    response?.response?.fileURL
                                ) {
                                    window.location.href =
                                        response?.response?.s3FileUrl ||
                                        response?.response?.fileURL;
                                }
                                handleClose();
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isVendorsToHubMapping) {
                        dispatchBulkUploadVendorsToHubs(
                            { fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                console.log('s3FileUrl response', response);
                                if (
                                    response?.response?.s3FileUrl ||
                                    response?.response?.fileURL
                                ) {
                                    window.location.href =
                                        response?.response?.s3FileUrl ||
                                        response?.response?.fileURL;
                                }
                                handleClose();
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isBulkEmpIDMapping) {
                        dispatchUploadBulkEmpIDMapping(
                            { fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                console.log('s3FileUrl response', response);
                                if (
                                    response?.response?.s3FileUrl ||
                                    response?.response?.fileURL
                                ) {
                                    window.location.href =
                                        response?.response?.s3FileUrl ||
                                        response?.response?.fileURL;
                                }
                                handleClose();
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else if (isTitanAdjustment) {
                        dispatchUploadTitanAdjustment(
                            state?.s3FileUrl,
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                if (response?.response?.s3FileUrl) {
                                    window.location.href =
                                        response?.response?.s3FileUrl;
                                }
                                handleClose();
                            },
                            () => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    } else {
                        dispatchBulkUploadStaffs(
                            { fileName: state?.s3FileUrl },
                            (response) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                                console.log('s3FileUrl response', response);
                                const url =
                                    response?.response?.s3FileUrl ||
                                    response?.response?.fileURL;
                                if (url) {
                                    setReportUrl(url);
                                } else {
                                    handleClose();
                                }
                            },
                            (resp) => {
                                toggleLoading(false);
                                setSubmitDisabled(false);
                            },
                        );
                    }
                });
            }}
        >
            {uiData?.buttonText
                ? uiData?.buttonText
                : enumType === 'payment'
                  ? 'Upload Payment'
                  : enumType === 'earning'
                    ? 'Upload Earnings'
                    : enumType === 'titan_adjustment'
                      ? 'Upload Adjustment'
                      : enumType === 'slots'
                        ? 'Upload Slots'
                        : isMultiOrgSlotsUpload
                          ? 'Upload (multi-org)'
                          : 'Upload Staffs'}
        </Button>,
    ];

    const handleInputChange = (value, key) => {
        setState((state) => ({
            ...state,
            [key]: value,
        }));

        setStateStatus(null); // formValidator(key, value);
    };
    return (
        <Modal
            onClose={handleClose}
            open={isOpen}
            maxWidth={isSlotAssign || isSlotsUpload || isMultiOrgSlotsUpload ? 'md' : undefined}
            title={
                uiData?.title
                    ? uiData?.title
                    : enumType === 'payment'
                      ? 'Upload Payment'
                      : enumType === 'earning'
                        ? 'Upload Earnings'
                        : enumType === 'titan_adjustment'
                          ? 'Upload Adjustments'
                          : enumType === 'slots'
                            ? 'Upload Slots'
                            : isMultiOrgSlotsUpload
                              ? 'Upload Slots (multi-org)'
                              : 'Upload Staffs'
            }
            subtitle={
                uiData?.subTitle
                    ? uiData?.subTitle
                    : enumType === 'payment'
                      ? 'Upload Payments of your staff'
                      : enumType === 'earning'
                        ? 'Upload Earnings of your staff'
                        : enumType === 'titan_adjustment'
                          ? 'Upload Adjustments of your staff'
                          : enumType === 'slots'
                            ? 'Upload Slots'
                            : isMultiOrgSlotsUpload
                              ? 'Bulk upload slots across every org — every row derives its own org from the hub it names'
                              : 'Bulk Upload Staffs'
            }
            actions={actions}
            loading={loading}
        >
            {isUploadEarnigs && (
                <Grid container>
                    <Grid item xs={12}>
                        <CustomTextField
                            label="Clients"
                            select
                            style={{
                                marginTop: '16px',
                                marginBottom: '16px',
                            }}
                            id="clients"
                            name="clients"
                            value={earningsClient}
                            onChange={(e) => {
                                setEarningsClient(e.target.value);
                            }}
                            error={false}
                            helperText={''}
                        >
                            <MenuItem value={'Blinkit'}>{'Blinkit'}</MenuItem>
                            <MenuItem value={'Others'}>{'Others'}</MenuItem>
                        </CustomTextField>
                    </Grid>
                    {earningsClient === 'Blinkit' && (
                        <>
                            <Grid item xs={12}>
                                <CustomTextField
                                    label="Earnings By"
                                    select
                                    style={{
                                        marginTop: '16px',
                                        marginBottom: '16px',
                                    }}
                                    id="earningsFor"
                                    name="earningsFor"
                                    value={earningsFor}
                                    onChange={(e) => {
                                        setEarningsFor(e?.target?.value);
                                    }}
                                    error={false}
                                    helperText={''}
                                >
                                    <MenuItem value={'Weekly'}>
                                        {'Weekly'}
                                    </MenuItem>
                                    <MenuItem value={'Daily'}>
                                        {'Daily'}
                                    </MenuItem>
                                </CustomTextField>
                            </Grid>
                            {earningsFor === 'Weekly' &&
                                weekList?.length > 0 && (
                                    <Grid item xs={12}>
                                        <CustomTextField
                                            label="Select Week"
                                            select
                                            style={{
                                                marginTop: '16px',
                                                marginBottom: '16px',
                                            }}
                                            id="selectedWeek"
                                            name="selectedWeek"
                                            value={selectedWeek}
                                            onChange={(e) => {
                                                setSelectedWeek(e.target.value);
                                            }}
                                            error={false}
                                            helperText={''}
                                        >
                                            {weekList.map((week, index) => (
                                                <MenuItem
                                                    value={week?.value}
                                                    key={index}
                                                >
                                                    {week?.label}
                                                </MenuItem>
                                            ))}
                                        </CustomTextField>
                                    </Grid>
                                )}
                        </>
                    )}
                </Grid>
            )}
            {!reportUrl && !withheldInfo && !appliedInfo && (
                <FileUploader
                    label={'Upload Support Document'}
                    placeholder={'Upload Support Document'}
                    onFileUploaded={(url) => {
                        console.log(url);
                        handleInputChange(url, 's3FileUrl');
                    }}
                    isRequired={true}
                    allowedExtensions={
                        isSlotAssign || isSlotsUpload || isMultiOrgSlotsUpload
                            ? ['xlsx']
                            : undefined
                    }
                />
            )}
            {withheldInfo && (
                <div style={{ marginTop: 16 }}>
                    <p style={{ marginBottom: 8, fontWeight: 500 }}>
                        No rows were applied — this file breaches at least one
                        slot's capacity threshold, so the whole file is held.
                    </p>
                    <p style={{ marginBottom: 12, color: '#666', fontSize: 13 }}>
                        <RoutedToLine
                            routedToTier={withheldInfo?.routedToTier ?? 'the next approver'}
                            approverNames={withheldInfo?.approverNames}
                            additionalApproverTier={withheldInfo?.additionalApproverTier}
                            additionalApproverNames={withheldInfo?.additionalApproverNames}
                            approverDeciderApplicable={withheldInfo?.approverDeciderApplicable}
                        />
                    </p>
                    {!!withheldInfo?.breachingRows?.length && (
                        <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Org ID</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Org Name</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Hub ID</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Hub Name</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Slot</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Date</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Start</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>End</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Released / Baseline</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}>Requested</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ddd' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {withheldInfo.breachingRows.map((row, index) => (
                                    <tr
                                        key={index}
                                        style={{ background: row?.breached ? '#fdeeee' : undefined }}
                                    >
                                        <td style={{ padding: '4px 8px' }}>{row?.orgId ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.orgName ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.hubId ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.hubName ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.slotShortName ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.slotDate ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.slotStartTime ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.slotEndTime ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>{row?.baselineCapacity ?? '-'}</td>
                                        <td style={{ padding: '4px 8px', fontWeight: 600 }}>{row?.requestedCapacity ?? '-'}</td>
                                        <td style={{ padding: '4px 8px' }}>
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    borderRadius: 4,
                                                    padding: '1px 6px',
                                                    fontSize: 11,
                                                    fontWeight: 800,
                                                    textTransform: 'uppercase',
                                                    background: row?.breached ? '#fdeeee' : '#eaf6ee',
                                                    color: row?.breached ? '#d94b4b' : '#15803d',
                                                }}
                                            >
                                                {row?.breached ? 'over limit' : 'ok'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}
                </div>
            )}
            {appliedInfo && (
                <div style={{ marginTop: 16 }}>
                    <p style={{ marginBottom: 8, fontWeight: 500 }}>
                        File applied successfully.
                    </p>
                    {appliedInfo?.s3FileUrl && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <a
                                href={appliedInfo.s3FileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    flex: 1,
                                    wordBreak: 'break-all',
                                    fontSize: 13,
                                    color: '#1976d2',
                                }}
                            >
                                {appliedInfo.s3FileUrl}
                            </a>
                        </div>
                    )}
                </div>
            )}
            {reportUrl && (
                <div style={{ marginTop: 16 }}>
                    <p style={{ marginBottom: 8, fontWeight: 500 }}>
                        Upload submitted! Your report will be ready in a few minutes (~50-100 users created per minute).
                    </p>
                    <p style={{ marginBottom: 12, color: '#666', fontSize: 13 }}>
                        Click the link below to open it once processing is complete:
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <a
                            href={reportUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                flex: 1,
                                wordBreak: 'break-all',
                                fontSize: 13,
                                color: '#1976d2',
                            }}
                        >
                            {reportUrl}
                        </a>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                                navigator.clipboard
                                    .writeText(reportUrl)
                                    .then(() => showMessage('URL copied!', 'success'))
                                    .catch(() => {})
                            }
                        >
                            Copy
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    dispatchUploadStaffInfo: (uploadType, data, onSuccess, onError) =>
        dispatch(UploadStaffInfo({ uploadType, ...data }, onSuccess, onError)),
    dispatchUploadClientsEarnings: (data, onSuccess, onError) =>
        dispatch(UploadEarningsExternalClient(data, onSuccess, onError)),
    dispatchBulkUploadStaffs: (data, onSuccess, onError) =>
        dispatch(BulkUploadStaffs(data, onSuccess, onError)),
    dispatchBulkUploadSlots: (data, onSuccess, onError) =>
        dispatch(UploadSlot(data, onSuccess, onError)),
    dispatchBulkAssignSlots: (data, onSuccess, onError) =>
        dispatch(bulkAssignDedicatedSlots(data, onSuccess, onError)),
    dispatchBulkUploadHubs: (data, onSuccess, onError) =>
        dispatch(UploadBulkHubs(data, onSuccess, onError)),
    dispatchBulkUploadBDVendors: (data, onSuccess, onError) =>
        dispatch(UploadBulkBDVendors(data, onSuccess, onError)),
    dispatchBulkUploadVendorsToHubs: (data, onSuccess, onError) =>
        dispatch(UploadBulkVendorsToHubs(data, onSuccess, onError)),
    dispatchUploadBulkEmpIDMapping: (data, onSuccess, onError) =>
        dispatch(UploadBulkEmpIDMapping(data, onSuccess, onError)),
    dispatchUploadTitanAdjustment: (fileName, onSuccess, onError) =>
        dispatch(uploadTitanAdjustment(fileName, onSuccess, onError)),
    dispatchMultiOrgSlotBulkUpload: (fileName, onSuccess, onError) =>
        dispatch(multiOrgSlotBulkUpload(fileName, onSuccess, onError)),
    dispatchGetCapacityApprovers: (onSuccess, onError) =>
        dispatch(getCapacityApprovers(onSuccess, onError)),
});

//export default connect(mapStateToProps, mapDispatchToProps)(UploadPayEarnModal);
const UploadPayEarnModalConnected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(UploadPayEarnModal);

function UploadPayEarnModalWrapper(props) {
    return <UploadPayEarnModalConnected {...props} />;
}
export default UploadPayEarnModalWrapper;
